import { render, staticRenderFns } from "./DataSourceCreate.vue?vue&type=template&id=2807a614&"
import script from "./DataSourceCreate.vue?vue&type=script&lang=ts&"
export * from "./DataSourceCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports